<template>
  <div class="agent-dashboard">
    <div v-if="!loaded" class="status-card">{{ $t('Loading...') }}</div>

    <div v-else-if="!isAgent" class="status-card">
      <div class="status-title">{{ statusTitle }}</div>
      <p class="status-text">{{ statusText }}</p>
      <button v-if="applyStatus !== 'pending'" class="gold-btn" @click="$router.push('/applyagent')">
        {{ applyStatus === 'refused' ? $t('Re-apply') : $t('Become Agent') }}
      </button>
    </div>

    <template v-else>
      <div class="section">
        <h3>{{ $t('Promotion Info') }}</h3>
        <div class="link-item">
          <label>{{ $t('Invite Link') }}</label>
          <div class="link-input">
            <input type="text" :value="promotionLink" readonly>
            <button class="copy-btn" @click="copyLink(promotionLink)">{{ $t('Copy') }}</button>
          </div>
        </div>
        <div class="qrcode-section" v-if="qrcodeUrl">
          <img :src="qrcodeUrl" :alt="$t('Promotion QR Code')">
        </div>
      </div>

      <div class="section">
        <h3>{{ $t('Agent Overview') }}</h3>
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-value">{{ home.l1_count || 0 }}</div>
            <div class="stat-label">{{ $t('Direct Count') }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ home.l2_count || 0 }}</div>
            <div class="stat-label">{{ $t('Second Count') }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ home.l3_count || 0 }}</div>
            <div class="stat-label">{{ $t('Third Count') }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ home.pending_commission | vnd }}</div>
            <div class="stat-label">{{ $t('Pending Commission') }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ home.settled_commission | vnd }}</div>
            <div class="stat-label">{{ $t('Settled Commission') }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'agentDashboard',
  data() {
    return {
      loaded: false,
      isAgent: false,
      applyStatus: 'none',
      promotionLink: '',
      qrcodeUrl: '',
      home: {
        l1_count: 0,
        l2_count: 0,
        l3_count: 0,
        pending_commission: 0,
        settled_commission: 0,
      },
    };
  },
  computed: {
    statusTitle() {
      if (this.applyStatus === 'pending') return this.$t('Agent Pending Review');
      if (this.applyStatus === 'refused') return this.$t('Agent Application Refused');
      return this.$t('Become Agent');
    },
    statusText() {
      if (this.applyStatus === 'pending') return this.$t('Please wait for review');
      if (this.applyStatus === 'refused') return this.$t('Agent Application Refused');
      return this.$t('Apply to become agent first');
    },
  },
  created() {
    this.loadHome();
  },
  methods: {
    loadHome() {
      this.$apiFun.get('/api/agent/home').then((res) => {
        this.loaded = true;
        if (res && res.code === 200 && res.data) {
          const data = res.data;
          this.isAgent = Number(data.is_agent) === 1;
          this.applyStatus = data.apply_status || 'none';
          this.home = {
            l1_count: data.l1_count || 0,
            l2_count: data.l2_count || 0,
            l3_count: data.l3_count || 0,
            pending_commission: data.pending_commission || 0,
            settled_commission: data.settled_commission || 0,
          };
          this.promotionLink = data.wap_url || data.normalLink || '';
          if (this.promotionLink) {
            this.qrcodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(this.promotionLink);
          }
        }
      }).catch(() => {
        this.loaded = true;
      });
    },
    copyLink(url) {
      if (!url) return;
      const done = () => {
        let vm = this;
        while (vm && !vm.showTost) {
          vm = vm.$parent;
        }
        if (vm && vm.showTost) {
          vm.showTost(1, this.$t('Link copied'));
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => {
          this.fallbackCopy(url);
          done();
        });
      } else {
        this.fallbackCopy(url);
        done();
      }
    },
    fallbackCopy(url) {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-dashboard {
  padding: 16px;
  color: #352b24;
}

.status-card,
.section {
  background: #ffffff;
  border: 1px solid #eadfd3;
  border-radius: 16px;
  padding: 18px 16px;
  margin-bottom: 16px;
  box-shadow: 0 5px 18px rgba(117, 73, 34, 0.08);
}

.status-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.status-text {
  color: #8a6a4a;
  font-size: 13px;
  margin: 0 0 16px;
}

.gold-btn,
.copy-btn {
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}

.gold-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
}

.section h3 {
  margin: 0 0 12px;
  font-size: 15px;
}

.link-item label {
  display: block;
  font-size: 13px;
  color: #8a6a4a;
  margin-bottom: 8px;
}

.link-input {
  display: flex;
  gap: 8px;

  input {
    flex: 1;
    height: 40px;
    border: 1px solid #ead1b2;
    border-radius: 8px;
    padding: 0 10px;
    background: #fff8ef;
    color: #352b24;
  }

  .copy-btn {
    padding: 0 14px;
    white-space: nowrap;
  }
}

.qrcode-section {
  margin-top: 16px;
  text-align: center;

  img {
    width: 160px;
    height: 160px;
    background: #fff;
    border: 1px solid #eadfd3;
    border-radius: 12px;
    padding: 8px;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.stat-card {
  background: #fff8ef;
  border: 1px solid #ead1b2;
  border-radius: 12px;
  padding: 14px 10px;
  text-align: center;
}

.stat-value {
  font-size: 18px;
  font-weight: 800;
  color: #8f501f;
}

.stat-label {
  margin-top: 6px;
  font-size: 12px;
  color: #8a6a4a;
}
</style>



// WEBPACK FOOTER //
// src/components/agent/agentDashboard.vue